import http from '@/plugin/axios'
// import { downloadFile } from '@/api/common/index'

export async function parse(this: any) {
  // return this.data.fileList.map((item: any) => {
  //   return {
  //     name: item.fileName,
  //     fileId: item.fileId
  //   }
  // })
}

export function beforeRemove(this: any, file: any) {
  this.fileList = this.fileList.filter((item: any) => item.fileId !== file.fileId)
}

export function submit(this: any, data: any) {
  const id = this.$route.params.id
  return http({
    url: '/srmData/sendSup',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: {
      id,
      sendRecordList: data.sendRecordList
    }
  })
}

export function clickFile(file: any) {
  http({
    url: '/srmFile/getFile',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: { fileId: file.id },
    useFactory: false,
    responseType: 'blob'
  }).then((res: any) => {
    console.log('res', res)
    const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
    const downloadElement = document.createElement('a')
    const href = window.URL.createObjectURL(blob) // 创建下载的链接
    downloadElement.href = href
    downloadElement.download = file.fileName // 下载后文件名
    document.body.appendChild(downloadElement)
    downloadElement.click() // 点击下载
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
  })
}
